/**
 * Ownership keys stored on `menu_modifiers.description` for the Roma dinner
 * loader. Guests must never see these; admin catalog pages may.
 */

export const ROMA_DINNER_OWNED_PREFIX = "roma-dinner:";
export const ROMA_DINNER_LEGACY_PREFIX = "Roma Southern Highlands dinner: ";

export function isInternalModifierOwnershipMarker(
  value: string | undefined,
): boolean {
  if (!value) return false;
  return (
    value.startsWith(ROMA_DINNER_OWNED_PREFIX) ||
    value.startsWith(ROMA_DINNER_LEGACY_PREFIX)
  );
}

/** Returns a guest-safe group description, or undefined when it is an internal key. */
export function guestFacingModifierDescription(
  description: string | undefined,
): string | undefined {
  if (!description || isInternalModifierOwnershipMarker(description)) {
    return undefined;
  }
  return description;
}

/** Drop internal keys if they ever appear as a modifier or option name. */
export function guestFacingModifierText(value: string | undefined): string {
  const trimmed = value?.trim() ?? "";
  if (!trimmed || isInternalModifierOwnershipMarker(trimmed)) return "";
  return trimmed;
}
